import React, {Suspense, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
// import Language from "./language";

import * as FaIcons from "react-icons/fa";
import BASIC_INFORMATION from '../../data/basic_data';
// import Section from "./section";
import {Link} from "react-router-dom";
import KyivClock from "../time/kiev";
// const SectionSupport = React.lazy(() => import('../components/section/support_section'));

function Footer() {
    const { t, i18n } = useTranslation();

    // const [service, setService] = useState([]);
    //
    // useEffect(() => {
    //     const data = localStorage.getItem('SERVICES');
    //     if ( data !== null ) setService(JSON.parse(data));
    // }, []);

    return (
        <div>
            <footer>
                <div className={'footer-links'}>

                    <div className="container-fluid bg-white pb-5 pt-5">

                        <div className="container row m-auto pb-5">
                            <div className="col-md-3 col-6 text-start">
                                <h5>
                                    {t('title.company')}
                                </h5>

                                <a href={'https://t.me/blvdltd'} className={'text-secondary'}><span className={'m-0'}>
                                    {t('button.contact-us')}
                                </span></a> <br/>
                                <a href={'/information/privacy-policy'} className={'text-secondary'}><span className={'m-0'}>
                                    Privacy policy
                                </span></a> <br/>
                                <a href={'/information/terms-of-service'} className={'text-secondary'}><span className={'m-0'}>
                                    Terms of Service
                                </span></a> <br/>
                                {/*<a href={'/contact-us'} className={'text-secondary'}><span className={'m-0'}>*/}
                                {/*    {t('button.Products')}*/}
                                {/*</span></a>*/}

                            </div>
                            <div className="col-md-3 col-6 text-start">
                                <h5>{t('form.social')}</h5>
                                <a href={BASIC_INFORMATION.socialInstagram} className={'text-secondary'}> <FaIcons.FaInstagram /> <span>Instagram</span></a> <br/>
                                {/*<a href={BASIC_INFORMATION.socialFacebook} className={'text-secondary'}> <FaIcons.FaFacebook /> <span>Facebook</span></a> <br/>*/}
                                <a href={BASIC_INFORMATION.socialLinkedIn} className={'text-secondary'}> <FaIcons.FaLinkedinIn /> <span>LinkedinIn</span></a><br/>

                            </div>
                            <div className="col-md-6 col-12 text-start">
                                <h5>{t('nav.about-us')}</h5>
                                <p>
                                    Blvd is a software development company with in-house expertise across multiple industries, specializing in complex, end-to-end software development, aiming to solve real-world business problems by creating cutting-edge, future-proof solutions.
                                </p>
                                {/*<a href={'/company'} className={'text-secondary'}><span className={'m-0'}>*/}
                                {/*    more info*/}
                                {/*</span></a>*/}
                                {/*<KyivClock />*/}
                            </div>
                        </div>

                        <div className="container d-flex justify-content-between align-items-center border-top pt-5">
                            <div className="col-md-6 p-1 text-start">
                                {/*<p id={'copyright'} className={'pb-1 pt-3 text-start text-secondary'}>{t('copyright')} © {(new Date().getFullYear())}.  {t('title')} Group.</p>*/}
                                {/*<img src="/assets/logo/ai.png" alt="logo" className={'img-fluid'}/>*/}
                                {/*<h3 className={'text-dark'}>STRD  <text className="text-warning1">Pro</text></h3>*/}
                                {/*<small className="text-secondary lead">🇺🇦️ Software Development</small>*/}
                                <small id={'copyright'} className={'text-muted text-small'}>Boulevard</small>
                            </div>

                            <div className="col-md-6 text-end">
                                <small id={'copyright'} className={'text-muted text-small'}>Copyright  © {(new Date().getFullYear())} </small>
                            </div>

                        </div>
                    </div>

                </div>
            </footer>
        </div>
    );
}

export default Footer;
